import { useQuery } from "@tanstack/react-query";
import { http } from "./http";

export const queryKeys = {
  me: "me",
  chats: "chats",
};
// ================================================================
//                              COMPETITION
// ================================================================

export const useMyChats = () => {
  return useQuery({
    queryKey: [queryKeys.me, queryKeys.chats],
    queryFn: http.getMyChats,
  });
};
